import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Receta } from "app/models/receta.interface";
import { Orden } from "app/models/orden.interface";

@Component({
  selector: "app-estudio-medico-dialog",
  templateUrl: "./estudio-medico-dialog.component.html",
  styleUrls: ["./estudio-medico-dialog.component.scss"],
})
export class EstudioMedicoDialogComponent {
  pacienteData: any = null;
  centroMedicoId: number | null = null;
  medicoId: number | null = null;

  constructor(
    public dialogRef: MatDialogRef<EstudioMedicoDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { formData: any; tipo: "estudio" | "receta" | "orden" | "odontograma" },
  ) {
    if (
      (data.tipo === "receta" || data.tipo === "orden" || data.tipo === "odontograma") &&
      data.formData?.paciente
    ) {
      const p = data.formData.paciente;
      this.pacienteData = {
        id: p.id,
        name: p.name || "",
        surname: p.surname || "",
        numeroDocumento: p.numeroDocumento || "",
        obraSocial: p.obraSocial || "particular",
      };
    }

    if (data.formData?.centrosMedicos?.length > 0) {
      this.centroMedicoId = data.formData.centrosMedicos[0].id;
    }

    if (data.formData?.medicoId) {
      this.medicoId = data.formData.medicoId;
    }
  }

  onListar() {
    this.dialogRef.close(true);
  }

  onRecetaCreada(_recetas: Receta[]) {
    this.dialogRef.close(true);
  }

  onOrdenCreada(_orden: Orden) {
    this.dialogRef.close(true);
  }

  onOdontogramaCreado(_id: number) {
    this.dialogRef.close(true);
  }
}
